import * as React from 'react';
import { UserState } from 'app/reducers/state';
import moment from 'moment';
import { each, filter, clone, find } from 'lodash';
import { Callout, Intent, Tabs, Tab, Button, TextArea, PopoverInteractionKind, Popover, H5, Icon, TabId, Spinner, H3, Overlay, RadioGroup, Radio } from '@blueprintjs/core';
import { API_CHARTBACK, executeQueryPostAuth } from 'app/utils/api';
import { renderTK, translateKey } from 'app/utils/forms';
import * as superagent from 'superagent';
import TextAreaV2 from '../TextAreaV2';

interface GameData {
    postFeedback: string;
    preFeedback: string;
    userID: string;
    objectives: GameDataObjective[];
    submitted: string;
    "game-id": string;
    scenario: string;
    results: string;
}

interface GameDataObjective {
    academicDescription: string;
    category: string;
    description: string;
    name: string;
    result: string;
    submitted: string;
}

function BASESCENARIOFROMNAME(scenario: string) {
    if (scenario.includes('scenario_2')) return 'scenario_2';
    if (scenario.includes('scenario_3')) return 'scenario_3';
    if (scenario.includes('scenario_4')) return 'scenario_4';
    if (scenario.includes('scenario_5')) return 'scenario_5';

    return 'scenario_1';
}

interface Props {
    user: UserState;
    selectedGame: GameData;
    canEditJournal?: boolean;
    inSimulator?: boolean;
    progressSoFar?: any;
    globalConfigs?: any;
    updateJournalDataInline?: (stage: string, payload: string, gameID: string) => void;
    updateJournalDataInlineAndContinue?: (stage: string, payload: string, gameID: string) => void;
    readyToRender?: () => void;
    hasSeenAllCategories?: () => void; // Optional hook that tells the parent component, when the viewer has looked at all
    // the categories
    customWarningStyle?: any;
    hideScore?: boolean;
    title?: string;
    originalJournalEntry?: string;
    showLessonObjectiveBreakdown?: boolean;


};

interface State {
    showPreAppend: boolean;
    showPostAppend: boolean;
    preAppendContent: string;
    postAppendContent: string;
    loadingAppendData: boolean;
    selectedTab: string;
    categorySeenMap: {};
    constructiveData: any;
    loadingConstructive: boolean;
    scoreHistory: [];
    letMeTryAgainState: boolean;
    letMeContinueState: boolean;
    tryAgainAppendedJournalCache: string;
    mcResults: {};
    currentMCSlot: any;
    currentMCSlotResponse: any;
    currentMCSlotResult: any;
    mcResponseBuffer: string;
    mcCoachingSeen: boolean;
}

export class KryPlayDetails extends React.Component<Props, State> {

    state: State = {
        showPostAppend: false,
        showPreAppend: false,
        loadingAppendData: false,
        preAppendContent: "",
        postAppendContent: "",
        categorySeenMap: {},
        selectedTab: "overview",
        constructiveData: {},
        loadingConstructive: true,
        scoreHistory: [],
        letMeTryAgainState: false,
        letMeContinueState: false,
        tryAgainAppendedJournalCache: "",
        mcResults: {},
        currentMCSlot: {},
        currentMCSlotResponse: undefined,
        mcResponseBuffer: "",
        currentMCSlotResult: undefined,
        mcCoachingSeen: false
    }

    componentDidMount() {
        // Mark the default tab as seen
        const categories = this.getAllCategories();
        const defaultTab = categories && categories.length > 0 ? "tb_single_" + categories[0] : undefined;
        this.markCategorySeen(defaultTab);

        this.dataCert(this.props.selectedGame['game-id']);

        // this.setState({
        //     currentMCSlot: clone(this.props.globalConfigs['dynamic_mc']) // TODO: make this scenario specific
        // })
    }

    getComputedCoachingConfig = () => {
        const {
            globalConfigs
        } = this.props;

        const matchingEntry = globalConfigs['computed_coaching'];

        return matchingEntry ? matchingEntry : {};
    }

    getResultsByScenario = (scenario: string) => {
        const {
            scoreHistory
        } = this.state;

        const filtered = filter(scoreHistory, entry => {
            return entry['scenario'] === scenario
        });

        // todo, might need to sort by submitted here


        // flatten down just the rsults
        let flattened: any[] = [];

        each(filtered, entry => {
            const entryResults = entry['results'];
            const erAsFloat = parseFloat(entryResults);

            flattened.push(
                erAsFloat * 100, 0
            );
        });

        return flattened;
    }

    averageOfLastThreePlays = (scenario: string) => {
        const history = this.getResultsByScenario(scenario);

        let entriesFound: number[] = [];

        for (let i = 0; i < 3; i++) {
            if (history[i] !== undefined) {
                entriesFound.push(history[i]);
            }
        }

        if (entriesFound.length === 0) return 0.0;

        let average = 0.0;

        each(entriesFound, entry => {
            average += entry;
        });

        return average / entriesFound.length;
    }

    getProgressSoFar = () => {
        const {
            progressSoFar,
            selectedGame
        } = this.props;

        const currentScenario = selectedGame.scenario;

        return progressSoFar[currentScenario];
    }

    markCategorySeen = (title) => {
        let newCategorySeenMap = clone(this.state.categorySeenMap);

        newCategorySeenMap[title] = 1;

        let newSeenTotal = Object.keys(newCategorySeenMap).length;
        let goalSeenTotal = this.getAllCategories().length;

        // Check for our has seen all categories hook
        if (newSeenTotal >= goalSeenTotal) {
            if (this.props.hasSeenAllCategories) {
                this.props.hasSeenAllCategories();
            }
        }

        this.setState({
            categorySeenMap: newCategorySeenMap
        });
    }

    getObjectiveStats = () => {
        const {
            selectedGame
        } = this.props;

        let total = 0;
        let achieved = 0;
        let process_total = 0;
        let process_achieved = 0;

        each(selectedGame.objectives, objective => {
            total += 1;

            if (objective.category.toLowerCase().includes("process")) {
                process_total += 1;
            }

            if (objective.result === "True" || objective.result === "true") {
                achieved += 1;

                if (objective.category.toLowerCase().includes("process")) {
                    process_achieved += 1;
                }
            }
        });

        return {
            total,
            achieved,
            process_total,
            process_achieved
        }
    }

    getAllCategories = () => {
        const {
            selectedGame
        } = this.props;

        let uniqueCategoryNames: string[] = [];

        each(selectedGame.objectives, objective => {
            if (!uniqueCategoryNames.includes(objective.category)) {
                uniqueCategoryNames.push(objective.category)
            }
        });

        return uniqueCategoryNames.sort();
    }

    getAllEntriesForACategory = (category: string) => {
        const {
            selectedGame
        } = this.props;

        return filter(selectedGame.objectives, objective => {
            return objective.category === category;
        });
    }

    getPreFeedback = () => {
        const {
            selectedGame
        } = this.props;

        if (selectedGame.preFeedback === "" || selectedGame.preFeedback === "None" || selectedGame.preFeedback === undefined) {
            return translateKey('vleader.notEntered');
        }

        return selectedGame.preFeedback;
    }

    getPostFeedback = () => {
        const {
            selectedGame
        } = this.props;

        if (selectedGame.postFeedback === "" || selectedGame.postFeedback === "None" || selectedGame.postFeedback === undefined) {
            return translateKey('vleader.notEntered');
        }

        return selectedGame.postFeedback;
    }

    getCanEditJouranl = () => {
        const {
            canEditJournal,
        } = this.props;

        const {
            showPostAppend,
            showPreAppend
        } = this.state;

        if (showPreAppend) {
            return false;
        }

        if (showPostAppend) {
            return false;
        }

        if (canEditJournal === true) {
            return true;
        }

        return false;
    }

    convertScenarioToFullName = (scenario: string) => {
        if (scenario === 'scenario_1') {
            return translateKey('vleader.scenario1Explore');
        }

        if (scenario === 'scenario_1_assess') {
            return translateKey('vleader.scenario1Assess');
        }

        if (scenario === 'scenario_1_a1') {
            return translateKey('vleader.lesson1');
        }

        if (scenario === 'scenario_1_a2') {
            return translateKey('vleader.lesson2');
        }

        if (scenario === 'scenario_1_a3') {
            return translateKey('vleader.lesson3');
        }
    }

    getCurrentRound = () => {
        const {
            selectedGame
        } = this.props;

        return parseInt(selectedGame['total-rounds']);
    }

    getPanelTitle = (): any => {
        const {
            selectedGame,
            hideScore
        } = this.props;

        const scoreResults = Math.round((parseFloat(selectedGame.results) * 100.0)) + "%";

        const {
            total,
            achieved,
            process_total,
            process_achieved
        } = this.getObjectiveStats();

        const showScore = !(hideScore === true);

        let objectiveWidget = <span style={{ marginLeft: '20px' }}>
            {'Achieved'}: <span className='score-circle'>{achieved.toString()}/{total.toString()}</span>
        </span>

        if (this.props.showLessonObjectiveBreakdown === true) {
            // split up our objective and process display
            let outcomes_total = Math.abs(total - process_total);
            let outcomes_achieved = Math.abs(achieved - process_achieved);

            objectiveWidget = <span style={{ marginLeft: '20px' }}>
                {'Outcomes'}: <span className='score-circle'>{outcomes_achieved.toString()}/{outcomes_total.toString()}</span>
                {' Process'}: <span className='score-circle'>{process_achieved.toString()}/{process_total.toString()}</span>
            </span>
        }

        return <span>
            <span>
                {this.convertScenarioToFullName(selectedGame!.scenario)}
            </span>
            {showScore ? <span style={{ marginLeft: '20px' }}>
                {translateKey('vleader.score')}: <span className='score-circle'>{scoreResults}</span>
            </span> : undefined}
            {showScore ? objectiveWidget : undefined}
            <span style={{ float: 'right', fontSize: '15px' }}>
                {translateKey('vleader.rounds')}: {this.getCurrentRound()}
            </span>
        </span>
    }

    renderCategoryPanel = (category: any) => {
        const categoryEntries = this.getAllEntriesForACategory(category);

        let entries: JSX.Element[] = [];

        each(categoryEntries, (entry) => {
            const isSuccessfull = entry.result === "True" || entry.result === "true";

            entries.push(
                <Popover
                    interactionKind={PopoverInteractionKind.HOVER}
                    boundary={"viewport"}
                    modifiers={
                        {
                            arrow: { enabled: true },
                            preventOverflow: { enabled: true }
                        }
                    }
                >
                    <Callout className={"single-view-callout " + (isSuccessfull ? "callout-green-icon" : "callout-red-icon")} icon={isSuccessfull ? "tick" : "minus"} title={entry.name}>
                        {entry.description}
                    </Callout>
                    <div style={{ maxWidth: '400px', padding: '10px', display: 'block' }}>
                        <H5>{translateKey('vleader.howToAchieve')}</H5>
                        {entry.academicDescription}
                    </div>
                </Popover>
            )
        });

        return <span style={{ width: '100%' }}>
            {entries}
        </span>
    }

    renderCategorySelection = () => {
        const categories = this.getAllCategories();

        let categoryMenu: JSX.Element[] = [];

        each(categories, category => {
            const categoryEntries = this.getAllEntriesForACategory(category);
            const categoryTotal = categoryEntries.length;
            const categorySuccess = filter(categoryEntries, (entry: GameDataObjective) => { return entry.result === "True" }).length;

            const menuLabel = "(" + categorySuccess.toString() + "/" + categoryTotal.toString() + ") " + category;

            categoryMenu.push(
                <Tab id={"tb_single_" + category} title={menuLabel} panel={this.renderCategoryPanel(category)} />
            );
        });

        const defaultTab = categories && categories.length > 0 ? "tb_single_" + categories[0] : undefined;

        return <span className="bold-tab-menu">
            <Tabs
                animate={true}
                defaultSelectedTabId={defaultTab}
                id="single_score_objective_view"
                key={"horizontal"}
                renderActiveTabPanelOnly={false}
                onChange={(navbarTabId: TabId) => {
                    // Mark it seen when the tab changes
                    this.markCategorySeen(navbarTabId);
                }}
                vertical={true}
            >
                {categoryMenu}
            </Tabs>
        </span>
    }

    updateFeedbackContent = (stage: string, feedback: string) => {
        this.setState({
            showPostAppend: false,
            showPreAppend: false,
            loadingAppendData: true,
            preAppendContent: "",
            postAppendContent: ""
        });

        const queryBase = "data/feedback/" + stage + "/" + this.props.selectedGame["game-id"];

        const existingContent = (stage === "pre") ? this.getPreFeedback() : this.getPostFeedback();

        const newPayload = existingContent + "\r\n" + moment().format("LLLL") + "\r\n" + feedback;

        executeQueryPostAuth(queryBase, {
            feedback: newPayload
        }, this.props.user, () => {
            // Refresh the page now

            //@ts-ignore
            this.props.updateJournalDataInline(stage, newPayload, this.props.selectedGame["game-id"]);

            this.setState({
                loadingAppendData: false
            });
        });
    }

    renderPreAppend = () => {
        const {
            showPreAppend,
            preAppendContent
        } = this.state;

        if (!showPreAppend) return undefined;

        return <span>
            <TextArea
                growVertically={true}
                large={true}
                intent={Intent.PRIMARY}
                style={{ width: '100%', marginBottom: '5px' }}
                onChange={(event) => {
                    this.setState({
                        preAppendContent: event.target.value
                    });
                }}
                value={preAppendContent}
            />
            {this.renderNormalButton("", () => {
                this.updateFeedbackContent("pre", preAppendContent);
            }, Intent.SUCCESS, "Save")}
        </span>
    }

    renderPostAppend = () => {
        const {
            showPostAppend,
            postAppendContent
        } = this.state;

        if (!showPostAppend) return undefined;

        return <span>
            <TextArea
                growVertically={true}
                large={true}
                intent={Intent.PRIMARY}
                style={{ width: '100%', marginBottom: '5px' }}
                onChange={(event) => {
                    this.setState({
                        postAppendContent: event.target.value
                    });
                }}
                value={postAppendContent}
            />
            {this.renderNormalButton("", () => {
                this.updateFeedbackContent("post", postAppendContent);
            }, Intent.SUCCESS, translateKey('vleader.save'))}
        </span>
    }

    renderNormalButton = (rightIcon: any, onClick: any, intent: any, text: string, disabled?: boolean) => {
        return <Button disabled={disabled} style={{ margin: '0px', width: '100%' }} rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
    }

    renderCardToRollover() {
        const {
            customWarningStyle
        } = this.props;

        if (customWarningStyle === undefined) {
            return <span className="badgeForMoreInfo">
                <Icon style={{ marginRight: '5px' }} icon="info-sign" />{renderTK('vleader.objectivesHover')}
            </span>
        }

        return <span style={customWarningStyle} className="badgeForMoreInfo">
            <Icon style={{ marginRight: '5px' }} icon="info-sign" />{renderTK('vleader.objectivesHover')}
        </span>
    }

    getOptions = (index: number) => {
        return [
            { label: 'Option 1', value: '1' },
            { label: 'Option 2', value: '2' },
            { label: 'Option 3', value: '3' },
            { label: 'Option 4', value: '4' }
        ]
    }

    renderMCSlot = () => {
        const {
            currentMCSlot,
            currentMCSlotResponse,
            currentMCSlotResult,
            mcCoachingSeen
        } = this.state;

        const currentQuestion = currentMCSlot.question;

        // If there's coaching and it hasn't been seen yet show it first
        if (currentMCSlot.coaching !== undefined && mcCoachingSeen === false) {
            return <div>
                <H3>Coaching</H3>
                <div style={{ display: 'block', width: '100%', padding: '20px', backgroundColor: '#faf5c3' }}>
                    {/* {this.getResultsByScenario('scenario_1').join(',')} */}
                    {currentMCSlot.coaching}
                    {/* This is where a constructed coaching message to round off your guidance would go:
                    Total Play with this scenario : {progress["total-plays"]}{" "}
                    Best Score so far             : {progress["best-score"]} */}
                </div>

                <div style={{ marginTop: '20px' }}>
                    {this.renderNormalButton("", () => {
                        this.setState({
                            mcCoachingSeen: true
                        });
                    }, Intent.SUCCESS, translateKey('vleader.continue'), false)}
                </div>
            </div>
        }

        let radioOptions: JSX.Element[] = [];

        each(currentMCSlot.answers, answer => {
            if (answer.answer === "OPEN") {
                let textInput = <span>
                    <TextAreaV2 onChange={(e: any) => {
                        //const newValue = e.target.value;

                        // this.setState({
                        //     tryAgainAppendedJournalCache: newValue
                        // });
                    }} defaultValue={""} className={"journalTextAreaV2"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                </span>

                radioOptions.push(
                    //@ts-ignore
                    <Radio label={textInput} value={answer.answer} />
                )
            }
            else {
                radioOptions.push(
                    <Radio label={answer.answer} value={answer.answer} />
                )
            }
        });

        return <span>
            <RadioGroup
                label={currentQuestion}
                onChange={(e) => {
                    //@ts-ignore
                    const val = e.target.value;

                    const buf = find(currentMCSlot.answers, answer => {
                        if (val === answer.answer) {
                            return true;
                        }
                    });

                    this.setState({
                        currentMCSlotResponse: val,
                        currentMCSlotResult: buf.response
                    });
                }}
                selectedValue={currentMCSlotResponse}
            >
                {radioOptions}
            </RadioGroup>

            <div style={{ marginTop: '20px' }}>
                {this.renderNormalButton("", () => {
                    if (currentMCSlotResult === undefined) {
                        // Done
                        const foundValue = JSON.stringify(this.state.mcResults);

                        //@ts-ignore
                        this.props.updateJournalDataInlineAndContinue('', foundValue ? foundValue : '', '');
                    }
                    else {
                        this.setState({
                            currentMCSlot: clone(currentMCSlotResult),
                            mcCoachingSeen: false
                        });
                    }
                }, Intent.SUCCESS, translateKey('vleader.continue'), false)}
            </div>
        </span>
    }

    renderFeedbackSlot = (index: number) => {
        let radioOptions: JSX.Element[] = [];
        const options = this.getOptions(index);

        each(options, option => {
            radioOptions.push(
                <Radio label={option.label} value={option.value} />
            )
        });

        return [
            <RadioGroup
                label={`M/C #${index.toString()}`}
                onChange={(e) => {
                    //@ts-ignore
                    const val = e.target.value;

                    let newBundle = clone(this.state.mcResults);

                    newBundle[index] = val;

                    this.setState({
                        mcResults: newBundle
                    });
                }}
                selectedValue={this.state.mcResults[index]}
            >
                {radioOptions}
            </RadioGroup>
        ]
    }

    isMcSaveButtonEnabled = () => {
        const {
            mcResults
        } = this.state;

        if (mcResults[0] !== undefined) {
            if (mcResults[1] !== undefined) {
                if (mcResults[2] !== undefined) {
                    if (mcResults[3] !== undefined) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    renderControlsForSection = () => {
        const RESULTS_SCREEN_BUTTON_STYLE = { width: '100%', marginTop: '10px' };

        const {
            letMeTryAgainState,
            tryAgainAppendedJournalCache
        } = this.state;

        // if (letMeContinueState) {
        //     return <div>
        //         {this.renderMCSlot()}
        //     </div>
        // }

        if (letMeTryAgainState) {
            return <div>
                <H3>Edit your plan using the coaching thoughts above</H3>
                <TextAreaV2 onChange={(e: any) => {
                    const newValue = e.target.value;

                    this.setState({
                        tryAgainAppendedJournalCache: newValue
                    });
                }} defaultValue={this.props.originalJournalEntry} className={"journalTextAreaV2"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>

                {this.renderNormalButton("", () => {

                    let foundValue = this.props.originalJournalEntry;

                    if (tryAgainAppendedJournalCache !== undefined && tryAgainAppendedJournalCache !== "") {
                        foundValue = tryAgainAppendedJournalCache;
                    }

                    //@ts-ignore
                    this.props.updateJournalDataInlineAndContinue('', foundValue ? foundValue : '', '');
                }, Intent.SUCCESS, translateKey('vleader.save'))}
            </div>
        }

        // Default to the initial controls
        return <div>
            <H3>Are you satisfied with this play or do you want to try again?</H3>
            <div style={{ width: '100%', flex: '1', flexDirection: 'column' }}>
                <div>
                    <Button onClick={() => {
                        // Done
                        const foundValue = JSON.stringify(this.state.mcResults);

                        //@ts-ignore
                        this.props.updateJournalDataInlineAndContinue('', foundValue ? foundValue : '', '');
                    }}
                        //@ts-ignore
                        style={RESULTS_SCREEN_BUTTON_STYLE} large intent={Intent.PRIMARY}>I’m Satisfied</Button>
                </div>
                <div>
                    <Button onClick={() => {
                        this.setState({
                            letMeTryAgainState: true
                        });
                    }}
                        //@ts-ignore
                        style={RESULTS_SCREEN_BUTTON_STYLE} large intent={Intent.SUCCESS}>Let Me Try Again</Button>
                </div>
            </div>
        </div>
    }

    renderCalculatedCoachingMessage = () => {
        const config = this.getComputedCoachingConfig();
        const progress = this.getProgressSoFar();

        let options = clone(config.statements).sort((a, b) => {
            return a.priority - b.priority;
        });

        /*
        progress example
            best-game-id: "7c3e1202-6766-4dee-9c5f-1a2a41149009"
best-max: "100.0"
best-score: "95.83333333333333"
initial-game-id: "8704b3e3-eb40-4a25-9922-521991b06f03"
initial-score: "12.5"
name: "scenario_1"
total-plays: "31"
        */


        let choosenMessage = 'No Message Matched';

        each(options, option => {
            const {
                atleastThisManyPlays, // int as string
                averageOfLastThreeScoresMax, // float as string
                averageOfLastThreeScoresMin, // float as string
                statement
            } = option;

            const playsToHaveDone = parseInt(atleastThisManyPlays);
            const playsDoneSoFar = parseInt(progress['total-plays']);

            // First make sure enough plays have been done
            if (playsDoneSoFar >= playsToHaveDone) {
                // Now make sure the average is in the correct range
                const playsSoFarScoreAverage = this.averageOfLastThreePlays(progress['name']);

                const _averageOfLastThreeScoresMax = parseFloat(averageOfLastThreeScoresMax);
                const _averageOfLastThreeScoresMin = parseFloat(averageOfLastThreeScoresMin);

                if (playsSoFarScoreAverage >= _averageOfLastThreeScoresMin) {
                    if (playsSoFarScoreAverage <= _averageOfLastThreeScoresMax) {
                        // Beacuse we sort by priority, we keep going down finding the highest
                        // priority match.  Then return that.
                        choosenMessage = statement;
                    }
                }
            }
        });

        return choosenMessage;
    }

    renderSimulatedSection = (data: any, scenario: string) => {
        const {
            letMeContinueState
        } = this.state;

        const {
            selectedGame
        } = this.props;

        const final = data.final;
        const successObjectives = data.successObjectives;
        const failedObjectives = data.failedObjectives;



        // const progress = this.getProgressSoFar();

        // Construct the successMessage
        //let successTemplate = 'Looking at how you played, you were <adjective triggered by percentage> <style name>. You were <2 hardest process objectives achieved> which helped you <list of outcome objectives achieved>.<Statement about style when successful>. <Statement about connections to chart>.<Statement about learner growth from this successful experience>';
        //let failureTemplate = 'Looking at how you played, you were not very <style name>. You did manage to <List of 2 hardest objectives Achieved> but you <list of 3 easiest unachieved objectives>.<Statement of how to achieve style which is also the plan> <Statement about style when you fail>.<Statement about learner growth from this unsuccessful experience>. Maybe try this again using some of my advice?';

        const topAchieved = this.getBottomAdjectives(successObjectives, 3, undefined);
        const notAchieved = this.getTopAdjectives(failedObjectives, 3, undefined);

        //const scoreResults = Math.round((parseFloat(selectedGame.results) * 100.0)) + "%";

        const styleName = this.convertScenarioToStyle(scenario);
        const scoreResultsAsScore = Math.round((parseFloat(selectedGame.results) * 100.0));
        const scoreResults = (scoreResultsAsScore >= 60) ? `You were ${styleName} enough to complete this lesson` : `You were not ${styleName} enough to complete this lesson`;

        if (scoreResultsAsScore >= 100) {
            const specialCompleteMessage = `There’s nothing more we can suggest to make this more ${styleName}.`;

            const message = <div style={{ marginTop: '10px', display: 'block', width: '100%' }}>

                <div style={{ display: 'block', width: '60%', margin: 'auto' }}>
                    <div>
                        <H3 style={{ textAlign: 'center', fontSize: '30px', marginTop: '30px', marginBottom: '50px' }}>{specialCompleteMessage}</H3>
                        <Button style={{ marginBottom: '30px', padding: '5px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} intent={Intent.NONE} text="View Score Details" onClick={() => {
                            this.setState({
                                selectedTab: 'objectives'
                            });
                        }} />
                    </div>
                    {/* {yellowCoachingWidget} */}
                </div>
                <div style={{ display: 'block', width: '60%', margin: 'auto', marginTop: '20px' }}>

                    <div style={{ display: 'block', width: '60%', margin: 'auto', marginTop: '20px' }}>
                        {this.renderControlsForSection()}
                    </div>

                </div>


            </div>

            return {
                score: final,
                message_success: message,
                message_fail: message,
                style: this.convertScenarioToStyle(scenario)
            }
        }

        if (letMeContinueState) {
            const message = <div style={{ marginTop: '10px', display: 'block', width: '100%' }}>

                <div style={{ display: 'block', width: '60%', margin: 'auto', marginTop: '20px' }}>

                    <div style={{ display: 'block', width: '60%', margin: 'auto', marginTop: '20px' }}>
                        {this.renderControlsForSection()}
                    </div>

                </div>


            </div>

            return {
                score: final,
                message_success: message,
                message_fail: message,
                style: this.convertScenarioToStyle(scenario)
            }
        }

        const yellowCoachingWidget = <div>
            <H3>Coaching</H3>
            <div style={{ display: 'block', width: '100%', padding: '20px', backgroundColor: '#faf5c3' }}>
                {/* {this.getResultsByScenario('scenario_1').join(',')} */}
                {this.renderCalculatedCoachingMessage()}
                {/* This is where a constructed coaching message to round off your guidance would go:
                Total Play with this scenario : {progress["total-plays"]}{" "}
                Best Score so far             : {progress["best-score"]} */}
            </div>
        </div>

        const message = <div style={{ marginTop: '10px', display: 'block', width: '100%' }}>
            <div style={{ display: 'block', width: '60%', margin: 'auto' }}>
                <div>
                    <H3 style={{ textAlign: 'center', fontSize: '30px', marginTop: '30px', marginBottom: '50px' }}>{scoreResults}</H3>
                    <Button style={{ marginBottom: '30px', padding: '5px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} intent={Intent.NONE} text="View Score Details" onClick={() => {
                        this.setState({
                            selectedTab: 'objectives'
                        });
                    }} />
                </div>
                {yellowCoachingWidget}
            </div>

            <div style={{ display: 'block', width: '60%', margin: 'auto', marginTop: '20px' }}>
                <div>
                    <H3>These are some of the things you did which were {styleName}. You:</H3>
                    <ul style={{ listStyle: 'none' }}>
                        {topAchieved}
                    </ul>
                </div>

                <div>
                    <H3>To make it more {styleName} you:</H3>
                    <ul style={{ listStyle: 'none' }}>
                        {notAchieved}
                    </ul>
                </div>

                {/* <div>
                    <H3>What you entered as your plan for this play</H3>
                    <TextAreaV2 defaultValue={this.props.originalJournalEntry} value={this.props.originalJournalEntry} readOnly={true} className={"journalTextArea"} rows={5} style={{width: '100%', height: '90px'}}></TextAreaV2>
                </div> */}

                <div style={{ display: 'block', width: '60%', margin: 'auto', marginTop: '20px' }}>
                    {this.renderControlsForSection()}
                </div>

            </div>


        </div>

        // const successMessage = successTemplate
        //     .replace('<adjective triggered by percentage>', '')
        //     .replace('<style name>', this.convertScenarioToStyle(scenario))
        //     .replace('<2 hardest process objectives achieved>', this.getBottomAdjectives(successObjectives, 2, "process"))
        //     .replace('<list of outcome objectives achieved>', this.getTopAdjectives(successObjectives, 10, "outcome"))
        //     .replace('<Statement about style when successful>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 2))
        //     .replace('<Statement about connections to chart>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 3))
        //     .replace('<Statement about learner growth from this successful experience>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 4));

        // const failureMessage = failureTemplate
        //     .replace('<style name>', this.convertScenarioToStyle(scenario))
        //     .replace('<List of 2 hardest objectives Achieved>', this.getBottomAdjectives(successObjectives, 2, undefined))
        //     .replace('<list of 3 easiest unachieved objectives>', this.getTopAdjectives(failedObjectives, 3, undefined))
        //     .replace('<Statement of how to achieve style which is also the plan>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 1))
        //     .replace('<Statement about style when you fail>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 5))
        //     .replace('<Statement about learner growth from this unsuccessful experience>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 6));


        return {
            score: final,
            message_success: message,
            message_fail: message,
            style: this.convertScenarioToStyle(scenario)
        }
    }

    getHasOverview = () => {
        const {
            title
        } = this.props;

        if (title) {
            return true;
        }

        return false;
    }

    getConfigInfo = (config: string, scenario: string, name: string) => {
        let response: any = undefined;

        const lines = config.split('\n');

        for (let i = 0; i < lines.length; i++) {
            const bits = lines[i].split('\t');

            try {
                if (bits[0] === scenario) {
                    if (bits[4] === name) {
                        const difficulty = parseInt(bits[5]);
                        const score = parseInt(bits[5]);
                        const successA = bits[8];
                        const failA = bits[9];

                        response = { difficulty, score, successA, failA };
                    }
                }
            }
            catch (e) { }
        }

        return response;
    }

    getAdjectiveIcon = (data: any, direction: number) => {
        if (direction < 0) {
            return <Icon style={{ marginRight: '10px', color: 'rgba(15, 153, 96, 0.5)' }} icon="confirm" />
        }

        return <Icon intent={Intent.WARNING} style={{ marginRight: '10px' }} icon="circle" />
    }

    getPositionedAdjectives = (_data: any[], max: number, direction: number, nameMatch: string) => {
        let data: any[] = [];

        const LIST_LI_STYLE = {
            maxWidth: '800px',
            marginBottom: '10px'
        }

        if (nameMatch === undefined) {
            data = _data;
        }
        else {
            for (let i = 0; i < _data.length; i++) {
                const name: string = _data[i].name;

                if (name.toLowerCase().includes(nameMatch.toLowerCase())) {
                    data.push(_data[i]);
                }
            }
        }

        if (data.length <= max) {
            let buffer2: any = [];

            for (let i = 0; i < data.length; i++) {
                buffer2.push(<li style={LIST_LI_STYLE}>{this.getAdjectiveIcon(data[i], direction)}{data[i].adjective}</li>);
            }

            return buffer2;
        }

        let buffer: any = [];

        for (let i = 0; i < max; i++) {
            // Do we count from the start of the array, or the back?
            const index = direction === 1 ? i : data.length - 1 - i;

            buffer.push(<li style={LIST_LI_STYLE}>{this.getAdjectiveIcon(data[i], direction)}{data[index].adjective}</li>);
        }

        if (direction === 1 && buffer.length === 0) {
            return <span>{"There wasn’t much more you could have done to be more directive"}</span>
        }

        return buffer;
    }

    convertScenarioToX = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 1;
        if (scenario === 'scenario_1_a2') return 2;
        if (scenario === 'scenario_1_a3') return 3;

        // Fallback to directive if we can't figure it out
        return 1;
    }

    convertScenarioToStyle = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 'Directive';
        if (scenario === 'scenario_1_a2') return 'Delegative';
        if (scenario === 'scenario_1_a3') return 'Participative';

        // Fallback to directive if we can't figure it out
        return 'Directive';
    }

    // Easiest, because the lowest difficulty objectives are at the top
    getTopAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, 1, nameMatch);
    }

    // Hardest because the highest difficulty objectives are at the bottom
    getBottomAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, -1, nameMatch);
    }

    getHighestStyle = () => {
        const {
            loadingConstructive
        } = this.state;

        if (loadingConstructive === false) {
            const intendedStyle = this.getCurrentShorthand().toLowerCase();

            return intendedStyle;
        }

        return '';
    }

    getHighestScore = () => {
        const {
            constructiveData,
            loadingConstructive
        } = this.state;

        if (loadingConstructive === false) {
            try {
                return parseFloat(constructiveData.coaching[this.props.selectedGame.scenario].final);
            }
            catch (e) {
                return '';
            }
        }

        return '';
    }

    getIsIntendedStyleMatching = () => {
        //@ts-ignore
        return this.getHighestScore() > 50.0;
    }

    renderSimulatedSectionConfig = (config: any) => {
        const pass = parseFloat(config.score) >= 65.0;

        const message = pass ? config.message_success : config.message_fail;

        return <div>
            {message}
        </div>
    }

    convertTitleToShorthand = (title: string) => {
        if (title === 'Directive Style') return 'directive';
        if (title === 'Delegative Style') return 'delegative';
        if (title === 'Participative Style') return 'participative';

        return 'transformational';
    }

    getCurrentShorthand = () => {
        const {
            title
        } = this.props;

        return this.convertTitleToShorthand(title ? title : '');
    }

    // wrap getting this users score history
    getScoreHistory = (userID: string, callback: any) => {
        superagent.
            get(API_CHARTBACK() + '?userID=' + userID + '&mock=user_score_history').
            end((error: any, response: any) => {
                try {
                    callback(JSON.parse(response.text));
                }
                catch (e) {

                }
            })
    }

    dataCert = (gameID: string) => {
        this.setState({
            loadingConstructive: true
        });

        this.getScoreHistory(this.props.user.id.toString(), (scoreHistory) => {
            superagent.
                get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&gameID=' + gameID + "&authenticationToken=" + this.props.user.authenticationToken + "&baseScenario=" + BASESCENARIOFROMNAME(this.props.selectedGame.scenario)).
                end((error: any, response: any) => {
                    try {
                        const b = JSON.parse(response.text);

                        if (b.coaching !== undefined) {
                            this.setState({
                                constructiveData: b,
                                loadingConstructive: false,
                                scoreHistory
                            });
                        }
                    } catch (e) {

                    }
                });
        });

    }

    processExtraScenarios = (gameID: string) => {

    }

    interpExtraScenarios = (a1, a2, a3, s1, config, configStatement) => {
        this.setState({
            constructiveData: {
                a1, a2, a3, s1, config, configStatement
            },
            loadingConstructive: false
        });
    }

    getSectionFromSheet2 = (configStatement: string, x: number, y: number) => {
        const lines: any[] = configStatement.split('\n');

        if (lines.length <= y) {
            return '';
        }

        const targetLine = lines[y];
        const bits = targetLine.split('\t');

        if (bits.length <= x) {
            return '';
        }

        return bits[x];
    }

    renderOverview = () => {
        const {
            constructiveData,
            loadingConstructive
        } = this.state;

        let innards = <Spinner />

        if (loadingConstructive === false) {
            const scenario = this.props.selectedGame.scenario;
            const section = this.renderSimulatedSection(constructiveData.coaching[scenario], scenario);

            innards = <span>
                {this.renderSimulatedSectionConfig(section)}
            </span>
        }

        return <span style={{ flexGrow: 1, flexBasis: 0, width: '100%' }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative' }}>
                    {innards}
                </span>
            </span>
        </span>
    }

    renderObjectives = (skipRollover: boolean) => {
        return <span>
            {skipRollover ? <span /> : this.renderCardToRollover()}
            <Callout className="playDetails" style={{ marginBottom: '10px', backgroundColor: 'white', width: '100%', marginTop: '30px' }} intent={Intent.NONE} icon={"play"} title={this.getPanelTitle()}>
                {this.renderCategorySelection()}
            </Callout>
        </span>
    }

    renderOverlayWrap = () => {
        const {
            selectedTab
        } = this.state;

        return <span>
            {/* <Button style={{marginBottom: '10px', padding: '5px'}} intent={Intent.SUCCESS} text="View Objectives" onClick={() => {
                this.setState({
                    selectedTab: 'objectives'
                });
            }} /> */}
            <Overlay hasBackdrop={true} isOpen={selectedTab === "objectives"} onClose={() => {
                this.setState({
                    selectedTab: 'overview'
                });
            }}>
                <div style={{ padding: '50px', marginTop: '20px' }}>
                    {this.renderObjectives(true)}
                </div>
            </Overlay>
            {this.renderOverview()}
        </span>
    }

    render() {
        // When in "old" mode just return this
        return this.renderObjectives(false);


        // if (this.getHasOverview()) {
        //     return this.renderOverlayWrap();
        // }
        // else {
        //     return this.renderObjectives(false);
        // }

        // return <Tabs id="resultsTabSet" onChange={(newTabID: TabId) => {
        //     this.setState({
        //         selectedTab: newTabID.toString()
        //     });
        // }} selectedTabId={selectedTab}>
        //     <Tab id="overview" title="Coaching" panel={} />
        //     <Tab id="objectives" title="All Objectives" panel={this.renderObjectives()} />
        //     <Tabs.Expander />
        // </Tabs>
    }
}
